module.exports = __webpack_public_path__ + "static/media/shouhuifapiao.9f57acd8.png";